export default "__VITE_ASSET__CXHXPY6K__"